// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4ddf33c3","732":"3181d153"}[chunkId] + ".chunk.js";
};